var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('AppBar'),_c('SideBar'),_c('ScheduleManagement')],1)}
var staticRenderFns = []

export { render, staticRenderFns }